import React, { useContext } from "react";
import { Helmet } from "react-helmet";

// Import assets
import bg from "../assets/cabanyal.png";
import calle from "../assets/calle.jpg";
import paella from "../assets/paella.jpg";
import playa from "../assets/playa.jpg";
import waveTransparent from "../assets/wave-transparent.png";
import waveWhite from "../assets/wave-white.png";
import waveBottom from "../assets/wave-bottom.png";
import waveBottomTransparent from "../assets/wave-bottom-transparent.png";
import { LanguageContext } from "../LanguageContext.jsx";
import text from "./text.jsx";

// Import components
import RightColumn from "../components/RightColumn";
import History from "../components/History/History";
import Restaurants from "../components/Restaurants";

function Cabanyal() {
  const { language } = useContext(LanguageContext);

  return (
    <>
      <Helmet>
        <title>Ruiz | Cabanyal</title>
        <meta
          lang={language}
          name="description"
          content={
            language === "en"
              ? "Discover Cabanyal, Valencia's vibrant and fashionable neighborhood. Explore our comprehensive guide to the best restaurants, activities, and hidden gems that make this district a must-visit spot. Whether you're a local or a visitor, let us help you experience Cabanyal and Valencia like never before."
              : "Descubre Cabanyal, el vibrante y moderno barrio de Valencia. Explora nuestra guía completa de los mejores restaurantes, actividades y lugares escondidos que hacen de este distrito un lugar de visita obligada. Ya sea que seas un local o un visitante, déjanos ayudarte a experimentar Cabanyal y Valencia como nunca antes."
          }
        />
      </Helmet>
      <main>
        <section>
          <div
            className="hero-cabanyal"
            style={{ backgroundImage: `url(${bg})` }}
          >
            <div className="hero-text">
              <h5>{text[language].title}</h5>
              <h1>{text[language].title2}</h1>
              <p>{text[language].subtitle}</p>
            </div>
            <div className="wave-div">
              <div>
                <img src={waveTransparent} alt="wave for design" />
                <img src={waveWhite} alt="wave for design" />
              </div>
            </div>
          </div>
        </section>
        <section className="bottom-section">
          <div className="container">
            <div className="wrap">
              <div className="content-flex">
                <div className="left">
                  <History text={text} language={language} calle={calle} />
                  <Restaurants
                    text={text}
                    language={language}
                    paella={paella}
                  />
                  <div>
                    <h2>{language === "en" ? "Beaches" : "Playas"}</h2>
                    <div
                      alt="A sand castle on the beach"
                      className="playa-img-div"
                      style={{ backgroundImage: `url(${playa})` }}
                    ></div>
                    <div className="topic-list">
                      <div className="topic-item">
                        <h3>Playa Cabanyal</h3>
                        <p>
                          {language === "en"
                            ? "Also known as Playa de las Arenas in honor of its famous hotel"
                            : "También conocida como Playa de las Arenas en honor a su famoso hotel"}
                        </p>
                      </div>
                      <div className="topic-item">
                        <h3>Playa de la Malvarrosa</h3>
                        <p>
                          {language === "en"
                            ? "Connected to Playa Cabanyal"
                            : "Conectada a la Playa Cabanyal"}
                        </p>
                      </div>
                      <div className="topic-item">
                        <h3>Playa de la Patacona</h3>
                        <p>
                          {language === "en"
                            ? "I recommend, it is a bit further away and hidden from the tourist's eye but it proposes less crowding and a very interesting offer of restaurants."
                            : "Yo recomiendo, se encuentra un poco más alejada y escondida al ojo del turista pero propone menos aglomeración y una oferta de restaurantes muy interesante."}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <RightColumn language={language} text={text} />
              </div>
            </div>
          </div>
          <div className="wave-div">
            <div>
              <img src={waveBottom} alt="wave for design" />
              <img src={waveBottomTransparent} alt="wave for design" />
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default Cabanyal;
